'use strict';

$ = jQuery;

/*
Conta a impressão de ofertas
Essa função é chamada no carregamento da página, carregamento de novas ofertas
no scroll infinito e na adição/remoção de um filtro de listagem.
*/

gtm_count_offers_impression();

function gtm_count_offers_impression() {

  // Impressões de produto
  var products = [];

  $('.offer-card:not(.impression-counted)').each(function (index, element) {
    var label = $(element).data('url');
    $(element).addClass('impression-counted');

    products.push({
      'brand': $(element).data('brand'),
      'id': $(element).find('a').data('offer'),
      'model': $(element).data('model'),
      'version': $(element).data('version'),
      'category': $(this).parent().data('category'),
      'price': 0,
      'year': $(element).data('year'),
      'gas': $(element).data('gas'),
      'transmission': $(element).data('transmission'),
      'doors': $(element).data('doors')
    });
  });

  dataLayer.push({
    'event': 'offerImpression',
    'eventCategory': 'Ofertas',
    'eventAction': 'Impressões',
    'ecommerce': {
      'impressions': products
    }
  });

  gtag('event', 'offerImpression', {
    'eventCategory': 'Ofertas',
    'eventAction': 'Impressões',
    'ecommerce': {
      'impressions': products
    }
  });
}

/*
Conta o número de cliques por oferta
*/

$(document).on("click", ".offer-card a", function (event) {

  var products = [];
  products.push({
    'brand': $(this).parents('.card').attr('data-brand'),
    'id': $(this).parents('.card').attr('data-id'),
    'model': $(this).parents('.card').attr('data-model'),
    'version': $(this).parents('.card').attr('data-version'),
    'category': $(this).parents('.card').attr('data-category'),
    'price': $(this).parents('.card').attr('data-price'),
    'year': $(this).parents('.card').attr('data-year'),
    'gas': $(this).parents('.card').attr('data-gas'),
    'transmission': $(this).parents('.card').attr('data-transmission'),
    'doors': $(this).parents('.card').attr('data-doors')
  });

  // dataLayer.push({
  //   'event': 'ga_event',
  //   'eventCategory': 'Oferta',
  //   'eventAction': 'Clique - Card - Filtro',
  //   'eventLabel': $(this).parents('.card').attr('data-brand') + ' ' + $(this).parents('.card').attr('data-title'),
  //   'ecommerce': {
  //     'click': {
  //       'actionField': {'list': 'Filtro'},
  //       'products': products
  //     }
  //   },
  // });

  // gtag('event', 'Oferta', {
  //   'eventCategory': 'Oferta',
  //   'eventAction': 'Clique - Card - Filtro',
  //   'eventLabel': $(this).parents('.card').attr('data-brand') + ' ' + $(this).parents('.card').attr('data-title'),
  //   'ecommerce': {
  //     'click': {
  //       'actionField': {'list': 'Filtro'},
  //       'products': products
  //     }
  //   },
  // });


  // dataLayerEstadao.push({
  //   'event': 'genericEvent',
  //   'genericCategory': 'conversao',
  //   'genericAction': $(this).parents('.card').attr('data-brand') + ' ' + $(this).parents('.card').attr('data-title'),
  //   'genericLabel': 'clique',
  //   'ecommerce': {
  //     'add': {
  //       'products': products
  //     }
  //   }
  // });

  // gtag('event', 'conversao', {
  //   'eventCategory': 'Oferta',
  //   'genericCategory': 'conversao',
  //   'genericAction': $(this).parents('.card').attr('data-brand') + ' ' + $(this).parents('.card').attr('data-title'),
  //   'genericLabel': 'clique',
  //   'ecommerce': {
  //     'add': {
  //       'products': products
  //     }
  //   }
  // });

});